import React from 'react'
import { FormActionBar, FormContainer } from 'scenes/Dashboard/components-next/Forms'
import { FormProps } from 'utils-next/forms'

import { Portal } from '@mui/material'

import { FastField } from '../../../../../../../../utils-next/forms'
import { TextField } from '../../../../../../components-next/Forms/Controllers'
import { FormSection } from '../../../../../../components-next/Sections'
import { useCorporateDataFormStyles } from '../../../../../UsersManager/scenes/UserDetailsView/components/UserDataForm/CorporateDataForm.styles'
import { ScoutingCampaignFormData } from './ScoutingCampaignDataForm.data'

export type ScoutingCampaignNewFormContentProps = FormProps<ScoutingCampaignFormData> & {
  actionBarRef: React.MutableRefObject<any>
}

export function ScoutingCampaignNewFormContent({
  isSubmitting,
  handleSubmit,
  actionBarRef,
}: ScoutingCampaignNewFormContentProps) {
  const { classes } = useCorporateDataFormStyles()
  return (
    <FormContainer disabled={isSubmitting}>
      <FormSection title="New Space">
        <div className={classes.formContainer}>
          <FastField
            component={TextField}
            label="Space name"
            name="name"
            className={classes.field}
            fullWidth
            required
            autoFocus
          />
          <FastField
            component={TextField}
            label="User Id (Owner)"
            name="userId"
            className={classes.field}
            required
            fullWidth
            multiline
          />
        </div>
        <div className={classes.formContainer}>
          <FastField
            component={TextField}
            label="Description"
            name="description"
            className={classes.field}
            required
            fullWidth
            multiline
          />
        </div>
      </FormSection>
      <Portal container={actionBarRef?.current}>
        <FormActionBar onSubmit={handleSubmit} />
      </Portal>
    </FormContainer>
  )
}
